import styled, { injectGlobal } from 'styled-components';
import theme from '../../config/theme';
import visbyRegular from '../../assets/fonts/VisbyCF-Regular.woff';
import visbyRegularOblique from '../../assets/fonts/VisbyCF-RegularOblique.woff';
import visbyDemiBold from '../../assets/fonts/VisbyCF-DemiBold.woff';
import visbyMediumOblique from '../../assets/fonts/VisbyCF-MediumOblique.woff';
import visbyHeavy from '../../assets/fonts/VisbyCF-Heavy.woff';

injectGlobal`
  html {
    font-size: 100%;
  }

  @font-face {
    font-family: "Visby";
    src: url(${visbyRegular}) format("woff");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "Visby";
    src: url(${visbyRegularOblique}) format("woff");
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: "Visby";
    src: url(${visbyDemiBold}) format("woff");
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: "Visby";
    src: url(${visbyMediumOblique}) format("woff");
    font-weight: 500;
    font-style: italic;
  }

  @font-face {
    font-family: "Visby";
    src: url(${visbyHeavy}) format("woff");
    font-weight: 700;
    font-style: normal;
  }


  body {
    font-family: 'Visby', sans-serif;
    font-size: ${theme.base.fontSize};
    line-height: ${theme.base.lineHeight};
    margin: 0;
    padding: 0;
  }

  input {
      font-family: inherit;
  }

  ::-moz-selection {
    background-color: ${theme.color.tealLight};
  }

  ::selection  {
    background-color: ${theme.color.tealLight};
  }
`;



// WEBPACK FOOTER //
// ./src/components/App/injectGlobalStyles.js